import styled from 'styled-components';

const PADDING_PX = 2;

export const ContainerStyled = styled.div`
  position: relative;
  box-sizing: border-box;
  padding: ${PADDING_PX}px;
`;

export const WrapperStyled = styled.div`
  overflow: hidden;
  border-radius: 8px;

  background: var(--ds-surface-hovered, var(--ds-fb-surface-hovered));
  border: 2px solid
    var(--ds-border-accent-blue, var(--ds-fb-border-accent-blue));
  box-shadow: var(--ds-shadow-raised, var(--ds-fb-shadow-raised));
`;

export const BadgeStyled = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(
    calc(50% - ${2 * PADDING_PX}px),
    calc(-50% + ${PADDING_PX}px)
  );
`;
